import AutocompleteArrayInputEx from "components/_extensions/react-admin/ra-ui-materialui/src/input/AutocompleteArrayInputEx";
import React from "react";
import { AutocompleteInput, ReferenceArrayInput, ReferenceInput } from "react-admin";

import { TextReadonlyReferenceInput } from "./TextReadonlyInput";

const defaultSort = {
	field: "first_name",
	order: "ASC",
};

const optionText = (r) => (r && r.id != null ? `${r.first_name} ${r.last_name}` : "");

// TODO: Not used
export const OSFCUserText = (props) => {
	return (
		<ReferenceInput
			sort={defaultSort}
			reference="company-users"
			{...props}
			filter={{ id: [props.record[props.source]] }}
		>
			<TextReadonlyReferenceInput optionText={optionText} />
		</ReferenceInput>
	);
};

export const OSFCUserSelectInput = ({ size, margin, enableGetChoices, ...props }) => {
	return (
		<ReferenceInput
			sort={defaultSort}
			reference="company-users-short"
			perPage={15}
			{...props}
			filter={{
				no_range: false,
				is_terminal: true,
				is_blocked: false,
				is_deleted: false,
				...props.filter,
			}}
			enableGetChoices={enableGetChoices}
		>
			<AutocompleteInput
				optionText={optionText}
				resettable
				options={{ InputProps: { size }, margin }}
			/>
		</ReferenceInput>
	);
};

export const OSFCUsersSelectInput = ({ size, enableGetChoices, ...props }) => {
	return (
		<ReferenceArrayInput
			sort={defaultSort}
			reference="company-users-short"
			perPage={15}
			{...props}
			filter={{
				no_range: false,
				is_deleted: false,
				is_blocked: false,
				is_terminal: true,
				...props.filter,
			}}
			enableGetChoices={enableGetChoices}
		>
			<AutocompleteArrayInputEx
				optionText={optionText}
				resettable
				options={{ InputProps: { size } }}
			/>
		</ReferenceArrayInput>
	);
};
